/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import Layout from "../../Components/Layout/Layout";
import Loader from "../../Components/Loader/Loader";
import { axiosInstance } from "../../Axios/https";
import { toast } from "react-toastify";

const Verification = () => {
  const [otp, setOtp] = useState("");
  const [loader, setLoader] = useState(false);
  const id = localStorage.getItem("id");
  const navigate = useNavigate();

  const handlerVerification = () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("user_id", id);
    formData.append("email_otp", otp);
    axiosInstance
      .post("client/verification", formData)
      .then((res) => {
        if (res?.data?.status === true) {
          console.log(res?.data?.data);
          toast.success(res?.data?.message);
          navigate("/login");
          setLoader(false);
        } else {
          toast.error(res?.data?.message);
          setLoader(false);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setLoader(false);
      });
  };

  return (
    <>
      <Layout>
        <div className="inner-page-banner">
          <div className="breadcrumb-vec-btm">
            <img
              className="img-fluid"
              src="assets/images/bg/inner-banner-btm-vec.png"
              alt=""
            />
          </div>
          <div className="container">
            <div className="row justify-content-center align-items-center text-center">
              <div className="col-lg-6 align-items-center">
                <div className="banner-content">
                  <h1>Verification</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Verification
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="banner-img d-lg-block d-none">
                  <div className="banner-img-bg">
                    <img
                      className="img-fluid"
                      src="assets/images/bg/inner-banner-vec.png"
                      alt=""
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="assets/images/bg/inner-banner-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h1-story-area two mb-120 pt-120">
          <div className="container">
            <div className="row gy-5 align-items-center justify-content-center">
              <div className="col-lg-6 d-flex flex-column justify-content-center align-items-center">
                <div className="section-title1">
                  <h2>Verification</h2>
                </div>
                <div className="story-content form-wrapper">
                  <OtpInput
                    inputStyle={{
                      width: "60px",
                      height: "60px",
                      margin: "10px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                    }}
                    value={otp}
                    onChange={setOtp}
                    numInputs={4}
                    renderSeparator={<span>-</span>}
                    renderInput={(props) => <input {...props} />}
                  />
                  <button className="account-btn" onClick={handlerVerification}>
                    {loader ? <Loader /> : "Verification"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Verification;
